import { Trans } from "@lingui/react/macro";
import React from "react";
import { logout, restoreSession } from "../userActions";
import { appNavigate, currentLocation } from "../navigation";
import { connect } from "react-redux";
import { asyncComponent } from "./AsyncComponent";
import { BigMessageView } from "../views/BigMessageView";

const AsyncProfileUpdateForcer = asyncComponent(
  () => import("../../settings/container/ConnectedProfileUpdateForcer"),
);

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
const mapDispatchToProps = {
  restoreSession,
  logout,
};

class RequireAuthComponent extends React.Component {
  constructor(props) {
    super(props);
    if (!props.user.email) {
      // No session to restore -> go to the login page ourselves. api.ts only
      // redirects on 401, but /user/ping answers "no session" with 404 by
      // design, so without this the guard spun on "Überprüfe Login" forever
      // (e.g. anonymous checkout -> Dashboard CTA).
      props.restoreSession().catch((e) => {
        console.log("restoring session failed, logging out");
        this.props.logout();
        const { pathname, search } = currentLocation();
        appNavigate("/?from=" + encodeURIComponent(pathname + search), {
          replace: true,
        });
      });
    }
  }

  profileFilledIn = () => Boolean(this.props.user.profile.street);

  render() {
    if (!this.props.user.email) {
      return (
        <BigMessageView
          banner="spinner"
          title={<Trans id={"base.checking_login"}>Überprüfe Login</Trans>}
          text={
            <Trans id={"base.login.stuck"}>
              Wenn nichts passiert, klicken Sie <a href="/">hier</a>
            </Trans>
          }
        />
      );
    }
    if (!this.profileFilledIn()) {
      return <AsyncProfileUpdateForcer />;
    }
    return this.props.children;
  }
}

export const GuardComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequireAuthComponent);
